import { resourceReducer, getResources } from 'redux-resource';
import { httpStatusCodes } from 'redux-resource-plugins';

const insuranceDevices = resourceReducer('insuranceDevices', {
  plugins: [httpStatusCodes],
});

export default insuranceDevices;

export const getDevices = (state) => getResources(state);
export const getDevice = (state, id) => state.resources[id];
export const getDevicesByContract = (state, contractId) =>
  getResources(state, ({ contract }) => {
    try {
      return contract === parseInt(contractId, 10);
    } catch (err) {
      return false;
    }
  });

export const getCreatedDeviceStatus = (state) =>
  state.requests.create && state.requests.create.status;
export const getCreatedDevice = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
